export const DELETE_CLIENT_CASE_DOCUMENT = 'DELETE_CLIENT_CASE_DOCUMENT';
export const DELETE_CLIENT_CASE_DOCUMENT_SUCCESS = 'DELETE_CLIENT_CASE_DOCUMENT_SUCCESS';
export const DELETE_CLIENT_CASE_DOCUMENT_FAIL = 'DELETE_CLIENT_CASE_DOCUMENT_FAIL';
